import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ProductInBasket, ShoppingCartState } from '../../actions/standalone';
import {
  selectPackagesInBasket,
  selectProductsInBasket,
  selectProductsList,
} from '../../actions/selector';
import { Product } from '../../../types';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Pipe({
    name: 'productPhoto',
    standalone: false
})
export class ProductPhotoPipe implements PipeTransform {
  productsList$ = this.store.pipe(select(selectProductsList));
  selectedProductsList$ = this.store.pipe(select(selectProductsInBasket));
  packagesInBasket$ = this.store.pipe(select(selectPackagesInBasket));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(selectedProductId: string): Observable<{ fileName: string }> {
    return this.selectedProductsList$.pipe(
      map((selectedProductsList) =>
        selectedProductsList.find(
          (value) => value.selectedProductId === selectedProductId
        )
      ),
      switchMap((selectedProduct) =>
        this.productsList$.pipe(
          map((productsList) => ({
            selectedProduct,
            product: productsList.find(
              (value) =>
                value.productId === selectedProduct?.productId ||
                value.productId === selectedProductId
            ),
          }))
        )
      ),
      map(({ selectedProduct, product }) => {
        const originalConfiguration: Array<{
          value: string | boolean | number;
          id: string;
        }> = [];
        const copyConfiguration: Array<{
          config: Array<{
            value: string | boolean | number;
            id: string;
          }>;
        }> = [];
        const photoConfig: Array<{
          fileName: string;
          config: Array<{
            value: string | boolean | number;
            id: string;
          }>;
        }> = [];

        if (selectedProduct) {
          Object.entries(selectedProduct.configuration).forEach((value1) => {
            originalConfiguration.push({ value: value1[1], id: value1[0] });
          });
          Object.entries(product.composedImages).forEach((image) => {
            if (product.composedImages[image[0]].config) {
              photoConfig.push({
                fileName: product.composedImages[image[0]].fileName,
                config: [],
              });
              const copyConfig = [];
              Object.entries(product.composedImages[image[0]].config).forEach(
                (value: {} | string) => {
                  if (typeof value[1]?.value === 'boolean') {
                    photoConfig
                      .find(
                        (value1) =>
                          value1.fileName ===
                          product.composedImages[image[0]].fileName
                      )
                      .config.push({ value: value[1].value, id: value[0] });
                    copyConfig.push(
                      originalConfiguration.find(
                        (value1) => value1.id === value[0]
                      )
                    );
                  }
                  if (typeof value[1]?.min === 'number') {
                    photoConfig
                      .find(
                        (value1) =>
                          value1.fileName ===
                          product.composedImages[image[0]].fileName
                      )
                      .config.push({ value: value[1], id: value[0] });
                    if (
                      value[1].min <=
                        originalConfiguration.find(
                          (value1) => value1.id === value[0]
                        )?.value &&
                      originalConfiguration.find(
                        (value1) => value1.id === value[0]
                      )?.value <= value[1].max
                    ) {
                      copyConfig.push({
                        value: value[1],
                        id: originalConfiguration.find(
                          (value1) => value1.id === value[0]
                        ).id,
                      });
                    }
                  }
                  if (typeof value[1]?.value === 'object') {
                    photoConfig
                      .find(
                        (value1) =>
                          value1.fileName ===
                          product.composedImages[image[0]].fileName
                      )
                      .config.push({ value: value[1].value[0], id: value[0] });
                    copyConfig.push(
                      originalConfiguration.find(
                        (value1) => value1.id === value[0]
                      )
                    );
                  }
                }
              );
              copyConfiguration.push({ config: [...copyConfig] });
            }
          });
        }
        let photo;
        photoConfig.forEach((copyConfig) => {
          if (
            copyConfiguration.find(
              (value1) =>
                JSON.stringify(value1.config) ===
                JSON.stringify(copyConfig.config)
            )
          ) {
            photo = photoConfig.find(
              (value2) =>
                JSON.stringify(value2.config) ===
                JSON.stringify(copyConfig.config)
            );
          }
        });
        if (photo) {
          return photo;
        } else {
          return product?.composedImages.find((value) => value.config === null);
        }
      })
    );
  }
}
